import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ReactDOMServer from "react-dom/server";
import { withRouter } from "react-router-dom";
import L from "leaflet";
import { Marker, Popup } from "react-leaflet";
import slugify from "../../utils/slugify";
import colors from "../../common/colors";

const { signaalkleuren } = colors;

const MarkerPopup = styled(Popup)`
  &.leaflet-popup {
    font-family: var(--eov-font);
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 50px;
  }
  .leaflet-popup-content-wrapper {
    color: ${colors.white};
    background-color: ${colors.logoblauw};
    border-radius: 3px;
  }
  .leaflet-popup-content {
    color: ${colors.white};
    margin: 0.25rem 0.5rem;
  }
  .leaflet-popup-tip {
    background-color: ${colors.logoblauw};
  }
  .leaflet-popup-tip {
    width: 12px;
    height: 12px;
  }
`;

function Icon(props) {
  const { color, active, obstructionType } = props;

  return (
    <svg viewBox="0 0 58 55" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter
          x="-39.8%"
          y="-41.7%"
          width="179.5%"
          height="183.3%"
          filterUnits="objectBoundingBox"
          id="a"
        >
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="3.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g filter="url(#a)" transform="translate(7 5)" fill="none" fillRule="evenodd">
        <path
          stroke={colors.hemelsblauw}
          strokeWidth={active ? 2 : 0}
          fill={color}
          d="M23.36.763l20.418 33.879c.446.74.2 1.698-.552 2.139-.244.143-.523.219-.808.219h-15.44L22 42l-4.945-5H1.582A1.571 1.571 0 0 1 0 35.44c0-.281.077-.557.222-.798L20.64.763a1.594 1.594 0 0 1 2.72 0z"
        />
        <path fill="#FFF" d="M22 4.325L39.904 34H4.114z" />
        {obstructionType === 1 ? (
          <g>
            <path d="M14 14h16v16H14z" />
            <path
              d="M25.014 23.737c.45-.59.945-.447 1.382.067 1.65 1.94 3.402 5.696 3.402 5.696H21c-.023.071.581-2.062 1.29-2.835.492-.538 1.47-.931 1.47-.931s.846-1.46 1.254-1.997zm-6.128-7.032c1.064-.037 2.15.965 2.336 1.356.37.782-.177 1.605-.016 3.016 0 0 .306 1.491.478 2.354l.026.13 1.965 1.335-.204.344-.052.087-4.604-3.127c.69 1.53 1.27 2.899 1.301 3.332.077 1.542.096 2.28.143 3.964-.045.002-1.09.04-1.287-1.105-.206-1.202-.344-2.09-.496-2.993l-1.04-1.97-2.677 5.935c-.12-.07-.914-.579-.567-1.614l2.206-6.636s.832.266 1.232.385c.05.015.089.01.106-.005l.01-.02-2.304-1.564c-.195.277-.331.476-.331.476-.288-.407-.338-.852-.09-1.28.198-.343.728-1.432 1.211-1.756.28-.183.368-.205.585-.26.741-.177 1.575-.368 2.07-.384zm1.262 3.054c-.293.487-.626 1.061-.925 1.585l-.217.381 1.646 1.118c-.147-.483-.37-1.38-.415-1.616-.05-.328-.09-.994-.09-1.468zm-3.397-1.538c-.125.065-.542.618-.925 1.148l-.095.132 1.031.7c.233-.51.587-1.275.978-1.942-.361-.06-.832-.119-.989-.038zm5.181-3.675c.634.377.79 1.011.345 1.758-.39.656-1.037.888-1.687.502-.65-.387-.79-1.011-.367-1.722.4-.674 1.042-.934 1.71-.538z"
              fill="#222"
            />
          </g>
        ) : obstructionType === 4 ? (
          <g>
            <path d="M14 14h19v19H14z" />
            <path
              d="M26.469 21.422h.292c2.29.014 3.352.183 3.663.508.242.252.657 1.076.895 1.934.308-.043.7-.077.883-.041.416.08.487.51.379.759-.052.119-.24.359-.533.56.477.64.655 1.077.655 2.114v2.832s-.038.83-.154 1.38c-.042.202-.267.345-.481.345h-1.74c-.214 0-.4-.22-.443-.421-.064-.308-.095-.503-.132-1.064h-6.569c-.037.561-.067.756-.132 1.064-.042.2-.228.42-.443.42H20.87c-.214 0-.44-.142-.481-.343-.116-.552-.155-1.38-.155-1.38v-2.833c0-1.037.179-1.473.655-2.115-.292-.2-.48-.44-.532-.56-.109-.248-.037-.678.378-.758.184-.036.576-.002.883.041.238-.858.653-1.682.895-1.934.325-.339 1.463-.508 3.956-.508zm1.781 7.422h-3.562v.593h3.562v-.593zm-6.346-2.171c-.26-.073-.524.145-.487.402l.06.416c.071.344.312.657.705.688l1.45.116c.087.008.158-.071.137-.15l-.161-.598a.886.886 0 0 0-.53-.548zm9.208-.013l-.078.013-1.174.326a.886.886 0 0 0-.53.548l-.161.598c-.022.079.05.158.136.15l1.45-.116c.393-.03.634-.344.706-.688l.06-.416c.037-.257-.227-.475-.487-.402zm-8.8-8.504c2.137 0 3.113.145 3.391.436.207.216.563.922.767 1.658.264-.038.6-.066.757-.036.314.061.398.354.35.569a41.303 41.303 0 0 0-1.961-.006c-.192-.62-.453-1.352-.537-1.495-.124-.062-1.033-.167-2.766-.167-1.734 0-2.643.105-2.767.167-.123.208-.62 1.664-.732 2.21.543.15 1.776.259 3 .283-.226.342-.465.843-.658 1.386a2.327 2.327 0 0 0-.545.02 1.15 1.15 0 0 0-.607.321l-.09.103-.054-.198a.751.751 0 0 0-.35-.421l-.104-.05-1.006-.279a.334.334 0 0 0-.42.273l.002.072.051.356c.055.262.224.504.498.573l.107.017 1.061.085c-.069.267-.05.56.06.81.055.127.148.266.272.406a3.057 3.057 0 0 0-.176.357l-.07.184h-.288a5.432 5.432 0 0 1-.113.912c-.031.147-.153.307-.302.35l-.078.01h-1.49c-.184 0-.377-.122-.413-.294-.092-.437-.127-1.075-.132-1.171v-2.44c0-.889.153-1.263.561-1.813-.25-.172-.412-.377-.456-.48-.093-.213-.032-.58.324-.65.158-.03.493-.002.757.036.204-.736.56-1.442.767-1.658.278-.29 1.254-.436 3.39-.436zm4.157 4.384l-.27.001c-1.847.01-2.82.125-2.958.194-.143.243-.723 1.942-.854 2.579.72.2 2.481.335 4.082.335l.284-.001c1.52-.015 3.12-.146 3.797-.334-.13-.637-.71-2.336-.854-2.579-.144-.072-1.205-.195-3.227-.195zm-7.719-7.353l.26.001c1.6.012 2.345.132 2.565.362.173.18.47.769.64 1.382.22-.031.5-.055.63-.03.297.058.348.365.27.542a.486.486 0 0 1-.038.067 37.8 37.8 0 0 0-1.532 0c-.16-.541-.413-1.255-.49-1.385-.103-.052-.86-.14-2.305-.14-1.444 0-2.202.088-2.305.14-.103.173-.517 1.387-.61 1.841.46.128 1.522.22 2.56.237-.226.27-.493.78-.7 1.347-.16-.007-.307 0-.422.022a1.084 1.084 0 0 0-.39.158l-.11.082-.066-.25a.626.626 0 0 0-.292-.35l-.087-.042-.839-.233a.278.278 0 0 0-.349.228l.001.06.043.296c.045.215.182.414.404.475l.1.017.856.069-.032.048a1.175 1.175 0 0 0-.037.995c.045.103.116.214.207.324l-.026.05-.025.05h-.227c-.026.4-.048.539-.094.759-.026.123-.128.256-.253.291l-.064.01h-1.242c-.153 0-.314-.103-.344-.246a7.608 7.608 0 0 1-.11-.974v-2.035c0-.74.127-1.053.468-1.51-.209-.144-.344-.316-.38-.4-.078-.178-.027-.485.27-.542.13-.026.41-.002.63.03.17-.614.467-1.202.64-1.383.22-.23.965-.35 2.565-.362h.52z"
              fill="#222"
            />
          </g>
        ) : obstructionType === 7 ? (
          <g>
            <path d="M0 0H20V20H0z" transform="translate(12 12)" />
            <path
              fill="#222"
              d="M16.247 16.95c-.235-.232-2.573-.34-4.353-.388-.002-.024.009-.07.09-.1.271-.102 1.732-.285 2.4-.322L11.506 1.752c-.059-.292-.315-.502-.613-.502H9.106c-.298 0-.554.21-.613.502L5.51 16.675c-.948.066-1.637.158-1.756.276-.156.155-.284.475-.284.862 0 .517.21.937.468.937h12.125c.26 0 .47-.42.47-.938 0-.386-.129-.706-.285-.861zM9.18 4.688h1.638l.563 2.813H8.619l.562-2.813zm-1.187 5.938h4.013l.57 2.85H7.423l.57-2.85z"
              transform="translate(12 12)"
            />
          </g>
        ) : obstructionType === 23 ? (
          <g>
            <path d="M12 13h20v20H12z" />
            <path
              d="M25.438 29.975l.375.281c.215.16.909.578 1.5.578.26 0 .54-.082.79-.187l.147-.065v1.321c-.291.093-.61.16-.938.16-.748 0-1.457-.337-1.875-.583-.417.246-1.126.582-1.875.582-.748 0-1.457-.336-1.875-.582-.417.246-1.126.582-1.875.582-.142 0-.283-.013-.42-.035l-.204-.039v-1.277c.204.072.42.123.625.123.545 0 1.183-.36 1.44-.535l.06-.043.374-.281.376.281c.215.16.909.578 1.5.578.545 0 1.183-.36 1.44-.535l.06-.043.375-.281zm6.25-3.225v5.313h-2.813V26.75h2.813zm-6.21-12.744a.615.615 0 0 1 .616 1.062l-.969.623v6.941l1.49-.86.938 1.623-8.99 5.191v3.476h-5V26.75h3.124v-4.977l1.217-1.221c.103-.12.02-.205.005-.216h-.007l-4.558 2.926a.313.313 0 0 1-.47-.178l-.55-1.97a.312.312 0 0 1 .157-.362zm-1.29 2.288l-5.625 3.615v6.512l5.625-3.247v-6.88z"
              fill="#222"
            />
          </g>
        ) : (
          <path
            d="M21.306 26.2c1.486 0 2.336.795 2.336 2.247 0 1.233-.79 2.192-2.306 2.192-1.486 0-2.336-.767-2.336-2.192 0-1.26.788-2.246 2.306-2.246zm2.2-14.2l-.35 8.127v4.077l-3.702.08v-11.99L23.506 12z"
            fill="#000"
            fillRule="nonzero"
          />
        )}
      </g>
    </svg>
  );
}

export const getSeverityColor = (obstruction = {}) => {
  const { obstructionType, hindrance, delay } = obstruction;
  if (obstructionType === 4) {
    // file
    if (delay > 30) {
      return signaalkleuren.rood;
    }
    if (delay > 10) {
      return signaalkleuren.oranje;
    }
    return signaalkleuren.donkergeel; //langzaam rijdend
  }
  if (obstructionType === 1) {
    // werkzaamheden
    if (hindrance === 3) {
      return signaalkleuren.rood;
    }
    if (hindrance === 2) {
      return signaalkleuren.oranje;
    }
    return signaalkleuren.donkergeel;
  }
  if (obstructionType === 6) {
    // omleiding
    return signaalkleuren.oranje;
  }
  if (obstructionType === 23) {
    // brug
    return signaalkleuren.rood;
  }
  return signaalkleuren.rood;
};

export const makeIcon = (obstruction, active) => {
  return L.divIcon({
    className: "my-div-icon",
    html: ReactDOMServer.renderToString(
      <Icon
        obstructionType={obstruction?.obstructionType}
        active={active}
        color={getSeverityColor(obstruction)}
      />,
    ),
    iconSize: [44, 42],
    iconAnchor: [22, 42],
  });
};

export function ObstructionMarker(props) {
  const {
    history,
    clickable,
    obstruction,
    markerIcon,
    active,
    location: { pathname = "" } = {},
  } = props;
  const { obstructionId, directionText, latitude = 0, longitude = 0 } = obstruction || {};
  const [isActive, setIsActive] = useState(active);

  const onMarkerClick = () => {
    const hinderUrl = `/hinder/${obstructionId}/${slugify(directionText)}`;
    // When currently showing an obstruction, replace the history. Otherwise add a new entry.
    // This ensures the back button on the obstruction works as intended.
    if (history.location.pathname.startsWith("/hinder/")) {
      history.replace(hinderUrl);
    } else {
      history.push({
        pathname: hinderUrl,
      });
    }
  };

  useEffect(() => {
    const shouldBeActive = pathname.indexOf(obstructionId) > 0 || active;
    setIsActive(shouldBeActive);
  }, [pathname, active, obstructionId]);

  const icon = markerIcon || makeIcon(obstruction, isActive);

  return (
    <Marker
      position={[latitude, longitude]}
      icon={icon}
      data={props}
      onClick={clickable ? onMarkerClick : null}
      interactive={clickable}
      color={getSeverityColor(obstruction)}
      onMouseOver={e => {
        e.target.openPopup();
      }}
      onMouseOut={e => {
        e.target.closePopup();
      }}
    >
      <MarkerPopup closeButton={false}>Toon details</MarkerPopup>
    </Marker>
  );
}

ObstructionMarker.defaultProps = {
  clickable: true,
};

export default withRouter(ObstructionMarker);
